import { render, staticRenderFns } from "./product-match.vue?vue&type=template&id=afcf482c&scoped=true"
import script from "./product-match.vue?vue&type=script&lang=js"
export * from "./product-match.vue?vue&type=script&lang=js"
import style0 from "./product-match.vue?vue&type=style&index=0&id=afcf482c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcf482c",
  null
  
)

export default component.exports